import type { StudentFormProps } from './student-form-props';
import type { StudentsListItemData } from './students-list-item-data';
import type { StudyPlansProps } from './study-plans-props';

export enum VisibleModalAssignReassignLicense {
  ASSIGN_REASSIGN_LICENSE = 'ASSIGN_REASSIGN_LICENSE',
  ASSIGN_REASSIGN_LICENSE_SUCCESS = 'ASSIGN_REASSIGN_LICENSE_SUCCESS',
}
export interface AssignReassignLicenseProps {
  reassignProps: StudentFormProps;
  assignProps: StudentFormProps;
  openAssignReassign: (studentsListItem: StudentsListItemData) => void;
  modalAssignReassignLicenseProps: {
    visibleModal?: VisibleModalAssignReassignLicense;
    visible: boolean;
    onCancel: () => void;
    studyPlansProps?: StudyPlansProps;
    license?: StudentsListItemData;
    isReassign: boolean;
    studentForm: StudentFormProps;
  };
}
